﻿(function (angular) {
  "use strict";

  var HTTP_OK = 200;

  angular.module("Toyota.Services").factory("Geolocation", [
    "$q",
    "$rootScope",
    function ($q, $rootScope) {
      var exports = this;
      var lastRequestResult = null;

      exports.getLastRequestResult = function () {
        return lastRequestResult;
      };

      exports.requestGeolocation = function () {
        var deferred = $q.defer();
        var geoLocServiceExists = "geolocation" in navigator;

        if (geoLocServiceExists) {
          // success
          const geoOnSuccess = (position) => {
            if (position) {
              var requestResult = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
                success: true,
                message: "pass",
              };
              deferred.resolve(requestResult);
              lastRequestResult = requestResult;
            }
          };

          // error
          var geoOnError = function (error) {
            var requestResult = {
              success: false,
              error: error,
              message: error,
            };
            deferred.reject(requestResult, HTTP_OK);
            lastRequestResult = requestResult;
            $rootScope.$broadcast("geolocation-permission-request-failed", error);
          };

          // getPosition call
          navigator.geolocation.getCurrentPosition(geoOnSuccess, geoOnError);
        } else {
          deferred.reject({
            success: false,
            message: "geoLocation is not supported",
          });
        }

        return deferred.promise;
      };

      return exports;
    },
  ]);
})(window.angular);
